// extracted by mini-css-extract-plugin
export var banner = "_r4-0";
export var settingRow = "_r4-2";
export var titleIcon = "_r4-1";